module.exports = __webpack_public_path__ + "static/media/ala.b7ce380b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/ala.png
// module id = 963
// module chunks = 0